import { ActiveRecord, sources } from '@mysidewalk/active-record';
/**
 * @memberof system-metadata
 * @property {number} id
 * @property {system-metadata.FeatureClass} featureClass
 * @property {number} minZoom
 * @property {number} maxZoom
 * @property {number} featureCount
 * @property {number} vertexCount
 * @property {number} area
 * @property {number} areaMean
 * @property {number} areaStddev
 * @property {number} perimeter
 * @property {number} perimeterMean
 * @property {number} perimeterStddev
 * @property {number} boundingDiagonalMean
 * @property {number} boundingDiagonalStddev
 * @property {number} simplificationTolerance
 * @property {boolean} isTopological
 */
class FeatureClassDetail extends ActiveRecord {
}
FeatureClassDetail.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordJSONAPISource,
};
export default FeatureClassDetail;
